export default "/_next/static/assets/images/hearken-placeholder-mobile.d41f354b8509436a604b4869e7629202.png";